<template>
  <v-dialog v-model="showDialog" persistent max-width="1000px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
      </v-card-title>-->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones tipo producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <h5>{{ producto.descripcion }}</h5>
          <br />
          <v-form ref="formInventarioProducto" :v-model="true" lazy-validation>
            <v-flex xs12 sm12 md8>
              <v-select
                v-model="inventarioProducto.sucursalId"
                :items="sucursales"
                item-text="nombreSucursal"
                item-value="sucursalId"
                label="Sucursal"
                placeholder="Sucursal"
                single-line
                :rules="[
                  () =>
                    !!inventarioProducto.sucursalId || 'El campo es requerido',
                ]"
                :loading="loadingSucursales"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12 sm12 md8>
              <v-select
                v-model="inventarioProducto.catalogoRowId"
                :items="catalogoProducto"
                item-text="descripcionCatalogo"
                item-value="catalogoRowId"
                label="SKU / Código del producto"
                placeholder="SKU / Código del producto"
                single-line
                :rules="[
                  () =>
                    !!inventarioProducto.catalogoRowId ||
                    'El campo es requerido',
                ]"
                :loading="loadingCatalogo"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12 sm12 md6>
              <v-text-field
                label="Cantidad renta"
                v-model="inventarioProducto.cantidadRenta"
                :rules="[
                  (v) =>
                    !!inventarioProducto.cantidadRenta ||
                    'El campo es requerido',
                ]"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6>
              <v-text-field
                label="Cantidad venta"
                v-model="inventarioProducto.cantidadVenta"
                type="number"
              ></v-text-field>
            </v-flex>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        <v-btn
          color="primary darken-4"
          :loading="$store.state.operationInProgress"
          @click="saveInventario"
          >Guardar</v-btn
        >
      </v-card-actions>

      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
        >Foto de producto guardada con éxito</v-alert
      >
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
    <snack-bar></snack-bar>
  </v-dialog>
</template>

<script>
//Components
import snackBar from "@/components/SnackBar";

//Sevices
import inventarioProductoService from "@/services/inventarioProductoService";
import sucursalService from "@/services/sucursalService";
import catalogoService from "@/services/catalogoProductoService";

export default {
  components: {
    snackBar,
  },
  props: {
    inventarioProducto: {
      type: Object,
    },
    producto: {
      type: Object,
    },
  },
  data() {
    return {
      showDialog: false,
      loadingSucursales: false,
      sucursales: [],
      loadingCatalogo: false,
      catalogoProducto: [],
      registroNuevo: true,
    };
  },
  mounted() {
    this.extraerSucursales();
    this.extraerCatalogo();
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    extraerSucursales() {
      let self = this;
      self.loadingColores = true;

      sucursalService
        .getAll()
        .then((result) => {
          self.sucursales = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingColores = false;
        });
    },
    extraerCatalogo() {
      let self = this;
      self.loadingTallas = true;

      catalogoService
        .getAllForDrop(self.producto.productoId)
        .then((result) => {
          self.catalogoProducto = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingTallas = false;
        });
    },
    saveInventario() {
      let self = this;

      if (self.$refs.formInventarioProducto.validate()) {
        self.operationStart();

        if (self.registroNuevo) {
          self.addInventario();
        } else {
          self.updateInventario();
        }
      }
    },
    addInventario() {
      let self = this;

      inventarioProductoService
        .add(self.inventarioProducto)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onInventarioProductoAdded", result);

          setTimeout(() => {
            self.$store.state.tituloForm = "MODIFICAR PRODUCTO";
            self.$store.state.iconoForm = "/images/general/actualizar-40.png";
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    updateInventario() {
      let self = this;

      inventarioProductoService
        .update(self.inventarioProducto)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onInventarioProductoUpdated", result);

          setTimeout(() => {
            self.$store.state.tituloForm = "MODIFICAR PRODUCTO";
            self.$store.state.iconoForm = "/images/general/actualizar-40.png";
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.$refs.formInventarioProducto.resetValidation();
      self.inventarioProducto.sucursalId = 0;
      self.inventarioProducto.catalogoRowId = 0;
      self.inventarioProducto.cantidadRenta = 0;
      self.inventarioProducto.cantidadVenta = 0;
    },
  },
};
</script>
